<template>
  <div id="rechargeB">
    <div id="cardSetUp">
      <div class="packagePanel" :style="{ 'padding-bottom': cheight + 'px' }">
        <h1 class="package-title-ka">
          <div>
            <div class="recordLoginText">{{ recordLoginText }}</div>
            <div class="recordLoginText1">客户卡号</div>
          </div>
        </h1>
        <van-tabs v-model="activeTab" class="package-tabs highlight-tabs" @click="tabChange">
          <van-tab title="月包套餐" name="monthly"></van-tab>
          <van-tab name="yearly">
            <template #title>
              <span class="highlight-tab">一年套餐</span>
            </template>
          </van-tab>
          <van-tab name="twoYears">
            <template #title>
              <span class="highlight-tab">两年套餐</span>
            </template>
          </van-tab>
        </van-tabs>

        <div style="display: flex; justify-content: space-between;flex-wrap: wrap;padding:0 13px;">
          <template v-for="item in filteredSimData">
            <div v-if="simData.length >= 1" :key="item.id" class="package p-se2"
              :class="{ 'label-defined-active': indexActive == item.id }" style="position: relative;"
              @click="changeState(item)">
              <div class="package-name">
                <h1 v-if="item.type == 11 || item.type == 16 || item.type == 18">
                  {{ item.packageName ? item.packageName : item.name }}</h1>
                <h1 v-else>{{ item.packageName ? item.packageName : item.name }}</h1>
                <p style="color:#BFA219;;font-weight :bold;text-align: center;font-size: 16px;display: flex;align-items:baseline;"
                  v-if="item.yearRemark && item.yearRemark.length > 2">
                  <img v-if="item.type != 2" src="@/assets/home/37.png"
                    style="width: 20px;vertical-align: bottom;margin-right: 2px;" />{{ item.yearRemark }}
                </p>
                <p v-else-if="(item.type == 17)">
                  有效期：30天有效期 套餐顺延生效，当月如需继续使用 请充值加油包。</p>
                <p v-else-if="(item.type == 10)">
                  有效期：每个月月底清零，流量包每月限购一次。用完可继续购买加油包使用。</p>
                <p v-else-if="(item.type == 14)">
                  有效期：每个月27号清零，套餐包可无限叠加使用。</p>
                <p v-else-if="(item.type == 15)">
                  有效期：每个月27号清零，套餐包用完可继续购买加油包使用。</p>
                <p v-else-if="(item.type == 3)">
                  有效期：每个月月底清零，再次购买顺延生效，流量用完请购买加油包。</p>
                <p v-if="item.type == 51">
                  30天有效期，用完可连续购买</p>
                <p v-if="(item.type == 41)">
                  套餐每30天含{{ item.flowRate / 1024 }}G流量，18个月有效，有效期内流量不够用，请充值加油包。 </p>
                <p v-else-if="(item.type == 2)">
                  有效期：每个月月底清零，套餐可无限叠加。</p>
                <p v-else-if="(item.type == 18 || item.type == 11 || item.type == 16 || item.type == 4)">
                  主套餐用完后，请购买此套餐,加油包可无限叠加使用</p>
                <p v-else-if="item.type == 111">
                  主套餐用完后，请购买此套餐,加油包7天有效，月底清零</p>
                <p v-else-if="(item.type == 20 || item.type == 31)">
                  套餐每30天含{{ item.flowRate / 1024 }}G流量，连续订购12个月，有效期内流量不够用，请充值加油包。 </p>
                <p v-else-if="(item.type == 21 || item.type == 30)">
                  套餐每个月含{{ item.flowRate / 1024 }}G流量，连续订购12个月。有效期内流量不够用，请充值加油包。 </p>
                <p v-else-if="(item.type == 25)">
                  套餐每个月含{{ item.flowRate / 1024 }}G流量 每月27号重新算套餐流量，一年有效，有效期内流量不够用，请充值加油包。 </p>
                <p v-else-if="(item.type == 26)">
                  套餐每个月含{{ item.flowRate / 1024 }}G流量 每月27号重新算套餐流量，半年有效，有效期内流量不够用，请充值加油包。 </p>
                <p v-else-if="(item.type == 24)">
                  套餐每30天含{{ item.flowRate / 1024 }}G流量，半年有效，有效期内流量不够用，请充值加油包。 </p>
                <p v-else-if="(item.type == 23)">
                  套餐每个月含{{ item.flowRate / 1024 }}G流量，半年有效，有效期内流量不够用，请充值加油包。 </p>
                <p style="color:red" v-if="item.remark">{{ item.remark }}</p>
                <p style="color:#BFA219;font-weight :bold;text-align: center;font-size: 16px;" v-if="item.redRemark">
                  <img src="@/assets/home/37.png" style="width: 20px;vertical-align: bottom;margin-right: 2px;" />{{
                    item.redRemark }}
                </p>
              </div>
              <div v-if="item.type === 10 || item.type === 17 || item.type === 2 || item.type === 15 ||
                item.type === 20 || item.type === 21 || item.type === 30 || item.type === 23 || item.type === 24 || item.type === 25 || item.type === 26
                || item.type === 40" class="package-price">
                <template
                  v-if="item.salePriceRmb > limitJuanPrice && result.subJuan && (result.subJuan.price || result.subJuan.vipSubPrice)">
                  <p v-if="item.showPrice && item.showPrice > 0">￥<span>{{ item.showPrice }}</span></p>
                  <p v-else-if="item.showYearPrice && item.showYearPrice > 0">￥<span>{{ item.showYearPrice }}</span></p>

                  <p v-else>￥<span>{{ (item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100) -
                    (result.subJuan.price ? result.subJuan.price * 1 : 0) - (result.subJuan.vipSubPrice ?
                      result.subJuan.vipSubPrice * 1 : 0) > 0 ?
                    ((item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100) - (result.subJuan.price ?
                      result.subJuan.price * 1 : 0) - (result.subJuan.vipSubPrice ? result.subJuan.vipSubPrice * 1 : 0
                      )).toFixed(2) : 0 }}</span></p>

                  <div class="fdaw">原价{{ item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100 }}</div>
                </template>
                <template v-else>
                  <p>￥
                    <span v-if="item.showYearPrice && item.showYearPrice > 0">{{ item.showYearPrice }}</span>
                    <span v-else>{{ item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100 }}</span>
                  </p>
                </template>
              </div>
              <div v-else class="package-price">
                <p>￥<span>{{ item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100 }}</span></p>
              </div>
              <div class="bottom">
                <div class="top-right">
                  <van-button type="primary" block color="#397EF5" @click="sumbit(item)">立即购买</van-button>
                </div>
              </div>
            </div>
          </template>
        </div>

        <h1 class="package-title">选择活动余额</h1>
        <div v-if="showjuan" class="quan">
          <div class="w-zh">优惠</div>
          <div v-if="showSalePrice && showSalePrice > 0" class="z-icon">
            <span>-￥{{ showSalePrice }}</span>
          </div>
          <div v-else class="z-icon" @click="lintTo"><span v-if="toatl">-￥{{ toatl }}</span></div>
        </div>



      </div>
    </div>
    <Checkstand :checkstand-style="checkstandStyle" :data-to-pay="dataToPay" :price="price" :type="type" :typeStyle=1
      :package-type-code="packageTypeCode" :primary-id="primaryId" :secondary-id="secondaryId"
      :isshowvip="!(isshowvip === 'false')" />

    <div ref="toRecharge" class="toRecharge">

      <!-- 
      <div class="renewal">
        <div class="renewal-flex">
          <div class="renewal-flex-left" @click="showNextInfo()">
            <div class="renewal-flex-left-top-flex">
              <div class="renewal-flex-left-top-flex-item1">
                <img src="@/assets/323.png" alt="">
              </div>
              <div class="renewal-flex-left-top-flex-item2">续费加油包</div>
              <div class="renewal-flex-left-top-flex-item3">
                <img src="@/assets/325.png" alt="">
              </div>
            </div>
            <div class="renewal-flex-left-content">流量用完自动订购加油包</div>
          </div>
          <div class="renewal-flex-right">
            <van-checkbox v-model="checked" @change="updateIsAutoState">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? require('@/assets/326.png') : require('@/assets/324.png')">
              </template>
            </van-checkbox>
          </div>
        </div>
      </div> -->


      <div v-if="showMonthChoose || isNaturalMonth" class="toRecharge-top">
        <van-radio-group v-model="isNextMonth" class="radio-group-defined">
          <div>
            <van-radio name="0" checked-color="#397EF5">本月生效</van-radio>
          </div>
          <div>
            <van-radio name="1" checked-color="#397EF5">次月生效</van-radio>
          </div>
        </van-radio-group>
      </div>

      <p v-if="isNaturalMonth" class="detail">请在有效时间内使用
        <span v-show="isNextMonth == 0">，<span>月底清零。</span></span>
        <span v-show="isNextMonth == 1">，<span>次月月底清零。</span></span>
      </p>

      <div v-if="showjuan" class="toRecharge-bottom">
        <!-- <p v-if="pkgShowYearPrice && pkgShowYearPrice > 0">金额：<span>{{ money_format(money_format(pkgShowYearPrice, 2, '.',
          ',') * 1) }}元</span></p> -->
        <p v-if="showSalePrice && showSalePrice > 0">金额：<span>{{ money_format(price, 2, '.', ',') - showSalePrice > 0
          ?
          money_format(money_format(price, 2, '.', ',') * 1 - showSalePrice) : 0 }}
            元</span><span v-if="toatl" style="font-size:12px;display:inline-block;padding-left:4px;">优惠
            ¥{{ showSalePrice }}</span></p>

        <p v-else>金额：<span>{{ money_format(price, 2, '.', ',') - toatl - vipSubPrice > 0 ?
          money_format(money_format(price,
            2, '.',
            ',') * 1 - toatl - vipSubPrice) : 0 }}
            元</span><span v-if="toatl || vipSubPrice" style="font-size:12px;display:inline-block;padding-left:4px;">优惠
            ¥{{ toatl + vipSubPrice }}</span></p>
        <div class="toRechargeBtn" @click="toRecharge()">
          <div class="n-btn">订 购</div>
        </div>
      </div>
      <div v-else class="toRecharge-bottom">
        <p>金额：<span>{{ money_format(price, 2, '.', ',') - 0 > 0 ? money_format(price, 2, '.', ',') - 0 : 0 }}
            元</span><span v-if="toatl" style="font-size:12px;display:inline-block;padding-left:4px;">优惠 ¥ 0</span></p>
        <div class="toRechargeBtn" @click="toRecharge()">
          <div class="n-btn">订 购</div>
        </div>
      </div>
    </div>

    <van-dialog v-model="reacheShow" title="规则" :show-confirm-button="false">
      <div class="dialog-text">套餐流量用完之后，自动使用余额购买加油包使用。</div>
      <div class="dialog-text">本功能可随时取消 取消后不再自动扣费。</div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="closeReacheShow">取消</van-button>
        <van-button type="primary" class="dialog-btn3" @click="toYueOrder">订购卡余额</van-button>
      </div>
    </van-dialog>

    <van-dialog v-model:show="yrShow" title="余额不足" :show-confirm-button="false">
      <div class="dialog-text">您的余额不足，请充值余额后订购套餐即可上网！</div>
      <div class="btn-vis1">
        <van-button type="primary" class="dialog-btn3" @click="nextPage">继续订购</van-button>
        <van-button type="default" class="dialog-btn2" @click="gopage">去参加充值活动</van-button>
        <div class="other-btn" @click="yrShow = false">查看其他套餐</div>
      </div>
    </van-dialog>

    <van-dialog v-model:show="limitYuFlg" title="余额不足" :show-confirm-button="false">
      <div class="dialog-text">{{ limitYuRemark }}</div>
      <div class="btn-vis1">
        <van-button type="primary" class="dialog-btn3" @click="gopage">去充值余额</van-button>
        <div class="other-btn" @click="limitYuFlg = false">查看其他套餐</div>
      </div>
    </van-dialog>


  </div>
</template>
<script>
import { wxRequest } from '@/api/user.js'
import { Dialog } from 'vant'
import Checkstand from '@/components/Checkstand'

export default {
  components: { Checkstand },
  data() {
    return {
      activeTab: 'monthly',
      filteredSimData: [],

      limitYuFlg: false,
      limitYuRemark: '',

      pkgShowYearPrice: 0,
      isShieldAgent: localStorage.getItem('isShieldAgent') == 1 ? true : false,

      vipSubPrice: 0,//此为VIP卡 立减金额，和toatl一样 单位元 只展示基础包
      showSalePrice: '', //此金额为 年包可以多用优惠卷 所以单独显示价格。
      reacheShow: false,
      recordLoginText: localStorage.getItem('recordLoginText'),
      indexActive: '',
      simData: [],

      itemInfo: {
        supplierTypeName: '',
        flowRate: '',
        salePriceRmb: ''
      },
      yrShow: false,
      showjuan: false, // 是否展示优惠卷
      toatl: 0,
      secondaryId: '',
      primaryId: '',
      isAdmin: '',
      isshowvip: localStorage.getItem("isShowVip"),  //是否展示VIP支付方式
      globalIsAdmin: '',
      isNextMonth: '0',
      payType: 1,
      isNaturalMonth: false,
      showCheckstand: false,
      showMonthChoose: false, // 判断是否显示本月次月

      // 收银台
      checkstandStyle: {
        height: '50%',
        transition: '0.8s !important'
      },
      cheight: null,
      dataToPay: {},
      price: 0,
      packageTypeCode: 0,
      type: '',
      mobile: localStorage.getItem('userPhone'),
      result: {},
      checked: false, // 0 开启  1关闭
      showLimit: 0, //0 不显示更多 1 显示更多

      limitJuanPrice: '', //限制大于多少金额 才能使用优惠卷
    }
  },
  watch: {
    isNaturalMonth: {
      handler(val) {
        this.$nextTick(() => {
          this.cheight = this.$refs.toRecharge.clientHeight
        })
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    // 根据选中的标签页过滤显示对应的套餐

  },
  created() {
    // this.$store.state.iccid = '898604D41825D0289548';
    // localStorage.setItem('iccid', '898604D41825D0289548');

    var data = {
      iccid: this.$store.state.iccid,
      isAdd: this.$route.query.isAdd
    }
    wxRequest('sim/user/soldPkg', data, 'get').then(res => {
      var result = res.data.data
      this.result = res.data.data
      if (res.data.code === '200' && result.list.length > 0) {
        this.simData = result.list
        this.simData.sort((a, b) => a.sort - b.sort)
        this.isAdmin = result.isAdmin
        this.globalIsAdmin = result.isAdmin
        this.itemInfo = this.simData[0]
        this.indexActive = this.simData[0].id
        this.isNaturalMonth = !!(this.simData[0].type === 2 || this.simData[0].type === 10 || this.simData[0].type === 15)
        this.price = this.simData[0].salePriceRmb ? this.simData[0].salePriceRmb : this.simData[0].salePrice / 100
        this.toatl = 0
        this.secondaryId = ''
        this.primaryId = ''
        this.pkgShowYearPrice = this.simData[0].showYearPrice;
        //不能使用优惠卷
        if (this.result.subJuan && this.result.subJuan.minUsePrice && this.price < this.result.subJuan.minUsePrice) {
          this.showjuan = false;
          this.limitJuanPrice = this.result.subJuan.minUsePrice;
        } else {
          this.showjuan = !!(this.simData[0].type === 2 || this.simData[0].type === 10 || this.simData[0].type === 15 || this.simData[0].type === 17 || this.simData[0].type === 20
            || this.simData[0].type == 21 || this.simData[0].type == 30 || this.simData[0].type == 31 || this.simData[0].type == 23 || this.simData[0].type == 24 || this.simData[0].type == 25 || this.simData[0].type == 26
            || this.simData[0].type == 40)
          if (this.result.subJuan && this.result.subJuan.vipSubPrice) {
            this.vipSubPrice = this.result.subJuan.vipSubPrice * 1;
          }
          if (this.$route.query.total) {
            this.toatl = this.$route.query.total * 1
            this.secondaryId = this.$route.query.secondaryId
            this.primaryId = this.$route.query.primaryId
          } else {
            this.toatl = result.subJuan.price * 1 || 0
            if (result.subJuan.types === 1) {
              this.secondaryId = result.subJuan.id
            } else {
              this.primaryId = result.subJuan.id
            }
          }
        }
        this.changeState(this.simData.filter(item => ![20, 21, 25, 30, 31, 40].includes(item.type))[0])
        this.filteredSimData = this.simData.filter(item => ![20, 21, 25, 30, 31, 40].includes(item.type));
      }
    })

    /** 每月倒数第6天默认选中次月生效**/
    var date = new Date()
    var year = date.getFullYear()
    var month = date.getMonth()
    var day = date.getDate()

    var date2 = new Date(year, month + 1, 0)
    var endDay = date2.getDate()
    day >= endDay - 5 ? this.isNextMonth = '1' : this.isNextMonth = '0'
  },
  mounted() {
    // this.selectIsAutoState()
  },
  methods: {
    tabChange(tab) {
      if (tab === 'monthly') {
        // 假设月包套餐类型包含这些值，根据实际业务调整
        this.changeState(this.simData.filter(item => ![20, 21, 25, 30, 31, 40].includes(item.type))[0])
        this.filteredSimData = this.simData.filter(item => ![20, 21, 25, 30, 31, 40].includes(item.type));
      } else if (tab === 'yearly') {
        // 一年套餐类型
        this.changeState(this.simData.filter(item => [20, 21, 25, 30, 31, 41].includes(item.type))[0])
        this.filteredSimData = this.simData.filter(item => [20, 21, 25, 30, 31, 41].includes(item.type));
      } else if (tab === 'twoYears') {
        // 两年套餐类型，根据实际业务补充
        this.changeState(this.simData.filter(item => [40].includes(item.type))[0])
        this.filteredSimData = this.simData.filter(item => [40].includes(item.type));
      } else {
        this.filteredSimData = this.simData;
      }
    },
    toYueOrder() {
      this.$router.push({ name: 'juanhuodongNew' })
      this.reacheShow = false
    },
    closeReacheShow() {
      this.reacheShow = false
    },
    showNextInfo() {
      this.reacheShow = true
    },
    updateIsAutoState() {
      const param = {
        iccid: this.$store.state.iccid,
        isAuto: this.checked ? 0 : 1
      }
      wxRequest('sysUser/account/update/isAuto/state/add', param, 'post').then(res => {
        if (res.data.code === '200') {
          this.selectIsAutoState()
        } else {
          Dialog.alert({ title: '修改提示', message: res.data.message })
        }
      })
    },
    selectIsAutoState() {
      const param = {
        iccid: this.$store.state.iccid
      }
      wxRequest('sysUser/account/select/isAuto/state/add', param, 'post').then(res => {
        if (res.data.code === '200') {
          this.checked = res.data.data === 0
        }
      })
    },
    lintTo() {
      this.$router.push({ name: 'coupon' })
    },
    changeState(item) {
      if (!item) return
      this.showSalePrice = item.showSalePrice;//此参数有个bug 就是余额 和 购买时 显示不正确
      this.pkgShowYearPrice = item.showYearPrice;// 金额单独显示
      this.indexActive = item.id
      this.itemInfo = item
      this.price = item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100
      this.type = item.type
      this.packageTypeCode = item.packageTypeCode

      if (item.isAdmin && item.isAdmin === 1) {
        this.isAdmin = item.isAdmin
      } else {
        this.isAdmin = this.globalIsAdmin
      }
      if (item.type === 10 || item.type === 17 || item.type === 2 || item.type === 15 || item.type === 25 || item.type === 26
        || item.type === 20 || item.type === 21 || item.type === 30 || item.type === 31 || item.type === 23 || item.type === 24
        || item.type === 40) {
        if (this.result && this.result.subJuan && this.result.subJuan.minUsePrice && this.price < this.result.subJuan.minUsePrice) {
          this.showjuan = false
          this.toatl = 0
          this.vipSubPrice = 0
          this.limitJuanPrice = this.result.subJuan.minUsePrice;
          this.secondaryId = '';
          this.primaryId = '';
        } else {
          this.showjuan = true
          if (this.result.subJuan && this.result.subJuan.vipSubPrice) {
            this.vipSubPrice = this.result.subJuan.vipSubPrice * 1;
          }
          if (this.$route.query.total) {
            this.toatl = this.$route.query.total * 1
            this.secondaryId = this.$route.query.secondaryId
            this.primaryId = this.$route.query.primaryId
          } else {
            this.toatl = 0
            if (this.result.subJuan) {
              this.toatl = this.result.subJuan.price * 1 || 0
              if (this.result.subJuan.types === 1) {
                this.secondaryId = this.result.subJuan.id
              } else {
                this.primaryId = this.result.subJuan.id
              }
            }
          }
        }

      } else {
        this.showjuan = false
        this.toatl = 0
        this.vipSubPrice = 0
        this.secondaryId = '';
        this.primaryId = '';
      }

      this.isNaturalMonth = !!(item.type === 2 || item.type === 10 || item.type === 14 || item.type === 15)
      this.showMonthChoose = !!(item.type === 2 || item.type === 14 || item.type === 15 || item.type === 10)
    },
    sumbit(data) {
      this.changeState(data)
      this.toRecharge()
    },
    nextPage() {
      var pop = {
        iccid: this.$store.state.iccid,
        pkgId: this.itemInfo.id,
        isAdmin: this.isAdmin,
        // secondaryId:this.secondaryId,
        // primaryId:this.primaryId,
        isNextMonth: this.isNextMonth
      }
      // 判断是否是月卡
      if (this.isNaturalMonth) {
        pop.isNextMonth = this.isNextMonth
      } else {
        pop.isNextMonth = '0'// 万能卡
      }
      if (this.tabbar === 1) {
        pop.pkgId = this.itemInfo.id
      } else {
        pop.pkgId = this.itemInfo.id
      }

      const self = this

      var data = {
        showLimit: this.showLimit,
        pkgShowYearPrice: this.pkgShowYearPrice,
        iccid: this.$store.state.iccid,
        soldPackageId: this.itemInfo.id,
        isAdmin: this.isAdmin,
        secondaryId: this.secondaryId,
        primaryId: this.primaryId,
        startTime: this.itemInfo.startTime,
        endTime: this.itemInfo.endTime,
        packageName: this.itemInfo.packageName ? this.itemInfo.packageName : this.itemInfo.name,
        price: this.toatl,
        vipSubPrice: this.vipSubPrice,
        showSalePrice: this.price,
        salePriceRmb: this.itemInfo.salePriceRmb - this.toatl * 1 - this.vipSubPrice * 1 > 0 ?
          this.money_format(this.itemInfo.salePriceRmb - this.toatl * 1 - this.vipSubPrice * 1, 2, '.', ',') : 0,
        mobile: this.mobile
      }
      // 判断是否是月卡
      if (this.isNaturalMonth) {
        data.isNextMonth = this.isNextMonth
      } else {
        data.isNextMonth = '0'// 万能卡
      }

      if (this.$store.state.source != false) {
        data.source = this.$store.state.source
      } else {
        data.source = 'xxgzh'
      }

      // this.$store.state.showCheckstand = true
      // this.$store.state.showCheckstandSource = 'flowRecharge'
      this.$router.push({
        path: '/user/rechargeSure',
        query: {
          params: encodeURIComponent(JSON.stringify(data))
        }
      })
      this.dataToPay = data
    },
    gopage() {
      this.$router.push({
        path: '/newUser/recharge'
      })
    },
    toRecharge() {
      if (this.pkgShowYearPrice && this.pkgShowYearPrice > 0) {
        this.nextPage()
      } else {
        //是否进行弹窗
        wxRequest('sim/select/showYu', { iccid: this.$store.state.iccid, pkgId: this.itemInfo.id }, 'post').then(res => {
          if (res.data.code === '200') {
            //弹窗
            this.showLimit = 1;
            this.yrShow = true
            return
          } else if (res.data.code === '404' || res.data.code === '405') {
            //弹窗
            this.showLimit = 1;
            this.limitYuFlg = true;
            this.limitYuRemark = res.data.message;
            return
          }
          this.nextPage()
        })
      }

    },

    // 第n天后
    afterManyDays(manyDays) {
      const startTime = new Date()
      const startDate = new Date(startTime)
      startDate.setDate(startDate.getDate() + manyDays)
      return this.dateFormat('yyyy-MM-dd', startDate)
    },

    // 本月最后一天
    lastDayOfThisMonth() {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth()
      return this.dateFormat('yyyy-MM-dd', new Date(year, month + 1, 0))
    },

    // 下个月第一天
    firstDayOfNextMonth() {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth()
      var day = date.getDate()

      const date2 = new Date(year, month + 1, 1)
      return this.dateFormat('yyyy-MM-dd', new Date(date2))
    },
    // 下个月最后一天
    lastDayOfNextMonth() {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth()
      return this.dateFormat('yyyy-MM-dd', new Date(year, month + 2, 0))
    },

    changePayType(type) {
      this.payType = type
    }
  }

}
</script>

<style lang="less" scoped>
.highlight-tabs {
  ::v-deep {

    // 基础样式
    .van-tabs__content {
      padding-top: 16px;
    }

    .van-tab {
      font-weight: 600;
      font-size: 17px;
      font-weight: bold;
      color: #666;
      padding: 12px 0;
      position: relative;
    }

    // 激活态样式
    .van-tab--active {
      color: #2D5BFF;
      font-weight: 700;
    }

    // 底部滑块动画
    .van-tabs__line {
      background-color: #2D5BFF !important;
      height: 3px !important;
      border-radius: 3px;
      transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    // 突出年包
    .highlight-tab {
      // color: #2D5BFF;
      background: url('~@/assets/home/37.png')no-repeat left center;
      background-size: 20px;
      padding-left: 22px;

      &:before {
        content: '';
        position: absolute;
        top: 5px;
        right: -8px;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        // background-color: #FF4D4F;
      }
    }
  }
}
</style>




<style>
#cardSetUp .flowPkg-choose {
  height: 36px;
}

#cardSetUp .flowPkg-choose .van-dropdown-menu__item {
  padding: 0 10px;
}

#cardSetUp .flowPkg-choose .van-dropdown-menu__title {
  display: contents;
}

#cardSetUp .flowPkg-choose .van-dropdown-menu__title .van-ellipsis {
  width: 100%;
}

#cardSetUp .flowPkg-choose .van-dropdown-menu__title::after {
  right: 10px;
}

#cardSetUp .flowPkg-choose .van-dropdown-item__content {
  padding: 0 20px;
}

#cardSetUp .flowPkg-choose .van-dropdown-item__content .van-cell {
  padding-left: 8px;
  padding-right: 8px;
}

#cardSetUp .checkstand-defined-popup .van-field__control {
  font-size: 24px;
}

#cardSetUp .checkstand-defined-popup input::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  font-size: 14px;
}

#cardSetUp .checkstand-defined-popup input::-moz-placeholder {
  /* Firefox 19+ */
  font-size: 14px;
}

#cardSetUp .checkstand-defined-popup input::-ms-input-placeholder {
  /* IE 10+ */
  font-size: 14px;
}

#cardSetUp .checkstand-defined-popup input::-moz-placeholder {
  /* Firefox 18- */
  font-size: 14px;
}

.changePasswordPanel-cardSetUp [class*=van-hairline]::after {
  border-color: #c4cedc;
}
</style>
<style lang="less" scoped>
.renewal {
  width: 90%;
  background: #F6F6F6;
  border-radius: 8px;
  margin: 20px auto;

  .renewal-flex {
    display: flex;
    align-items: center;
    padding: 14px 16px;
    justify-content: space-between;

    .renewal-flex-left-top-flex {
      display: flex;

      .renewal-flex-left-top-flex-item1,
      .renewal-flex-left-top-flex-item3 {
        width: 16px;
        height: 16px;
        margin-right: 4px;

        img {
          width: 100%;
        }
      }

      .renewal-flex-left-top-flex-item2 {
        color: #28292D;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        margin-right: 4px;
      }
    }

    .renewal-flex-left-content {
      color: #63666D;
      font-size: 12px;
      font-weight: 400;
      margin-top: 10px;
    }

    .renewal-flex-right {
      width: 20px;
      height: 20px;

      .van-checkbox {
        overflow: auto;

        ::v-deep.van-checkbox__icon {
          width: 100%;
          height: 100%;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}

.package-title {
  color: #333;
  font-size: 18px;
  margin-top: 24px;
  margin-bottom: 16px;
  font-weight: bold;
  margin-left: 20px;
}

.quan {
  margin: 12px 13px;
  background: #F6F6F6;
  display: flex;
  align-items: center;
  border-radius: 8px;
  height: 52px;

  div {
    width: 46%;
  }

  .w-zh {
    color: #28292D;
    font-size: 18px;
    padding-left: 20px;
    font-weight: 600;
  }

  .z-icon {
    text-align: right;
    background: url('../../assets/hd/arrow.png')no-repeat 90% center;
    padding-right: 36px;
    color: #397EF5;
    height: 20px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }
}

#cardSetUp {
  background: #F4F3F3;

  .cardSetUp-top {
    min-height: 180px;
    padding: 30px 20px 10px 20px;
    margin-bottom: 20px;
    background: #fff;

    p {
      margin-bottom: 10px;
      padding-left: 10px;
      line-height: 36px;
      font-size: 16px;
    }

    h1 {
      margin-bottom: 10px;
      padding-left: 10px;
      font-weight: bold;
    }

    .flowPkg-choose {
      background: #F4F3F3;
    }

  }

  .bottom {
    display: flex;
    justify-content: end;
    align-items: center;
    padding: 0px 13px 14px 14px;
    width: 100%;

    .top-left {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #28292D;
      padding: 6px;
      padding-left: 20px;
      text-align: center;
      background: #FFF4EB url('../../assets/new/newCopy/icon09.png') no-repeat 3px center;
      background-size: 12px 12px;
      border-radius: 2px;
    }

    .top-right {
      width: 90px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #C4C4C4;
      line-height: 20px;

      .van-button {
        height: 32px;
      }
    }
  }

  .packagePanel {


    .package-title-ka {
      // width: 100%;
      height: 77px;
      background: url("../../assets/img/12345.png") no-repeat;
      background-size: 100% 100%;
      padding: 0 12px;
      font-size: 18px;
      font-weight: bold;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .recordLoginText {
        display: block;
        font-size: 18px;
        margin-left: 56px;
        margin-bottom: 6px;
      }

      .recordLoginText1 {
        display: block;
        font-size: 12px;
        margin-left: 56px;
        font-weight: normal;
      }
    }

    .p-se {
      background: #E1EDFF;
    }

    .p-se2 {
      background: #EFEFEF;
    }

    .p-se3 {
      background: #FEECE0;
    }

    .package {
      width: 100%;
      display: flex;
      position: relative;
      margin-bottom: 10px;
      border-radius: 11px;
      flex-wrap: wrap;

      .package-name {
        flex-grow: 1;
        padding: 12px 0 0 16px;

        h1 {
          margin: 5px 0;
          color: #28292D;
          font-weight: bold;
          font-size: 18px;
        }

        p {
          margin: 10px 0;
          font-weight: 500;
          color: #63666D;
          width: 200px;
          line-height: 17px;
          font-size: 12px;
        }
      }

      .package-price.overlay-package {
        border-color: #07c160;
        background: #07c160;
      }

    }

    .label-defined {
      display: block;
      border-width: 14px 18px 14px 18px;
      border-style: solid;
      border-color: transparent;
      position: absolute;

      label {
        position: absolute;
        left: -14px;
        top: -12px;
        background: transparent;
      }
    }

    .label-defined-active {
      // border-color: red transparent transparent red;
      background: #EFF5FF;
      border: 1px solid #397EF5;
    }

    .package4 {
      width: 169px;
      height: 147px;
      background: #E1EDFF;
      border-radius: 4px;
      margin-bottom: 8px;

      .package4-name {
        flex-grow: 1;
        padding: 13px 13px 0;

        h1 {
          margin: 5px 0;
          color: #0D7FC6;
          font-weight: bold;
          font-size: 18px;
        }

        p {
          margin: 10px 0;
          font-weight: 500;
          color: #63666D;
          line-height: 17px;
          font-size: 12px;
        }
      }

      .package4-price {
        display: flex;
        margin-left: 11px;
        align-items: center;
        width: 110px;
        height: 28px;
        // background: linear-gradient(144deg, #FB674A 1%, #FE9C54 99%);
        border-radius: 14px;
        justify-content: center;

        p {
          font-size: 14px;
          font-weight: bold;
          color: #397EF5;

          span {
            font-size: 24px;
          }
        }
      }
    }
  }

  .fdaw {
    font-size: 14px;
    color: #397EF5;
    text-align: right;
    margin-top: 6px;
    width: 100%;
    text-decoration: line-through;
  }

  .toRecharge {
    position: fixed;
    width: 100%;
    bottom: 0;
    font-size: 16px;

    .toRecharge-top {
      display: flex;
      background: #fff;

      .radio-group-defined {
        display: flex;
        padding-left: 20px;
        justify-content: center;
        align-items: center;
        height: 40px;

        div {
          height: 20px;
          margin-right: 15px;
        }
      }

    }

  }

  .cardSetUp-middle {
    padding: 0 15px 10px;

    .cardSetUp-middle-title {
      font-weight: bold;
      font-size: 18px;
      //line-height: 30px;
      margin-bottom: 10px;
    }

    .package-choose {
      padding: 16px 8px 9px;
      background: #fff;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      text-align: center;
    }

    .package-choose-item {
      padding: 0;
      height: 81px;
      flex-basis: 30%;
      margin-bottom: 9px;
      border: 1px solid #C9C9C9;
      border-radius: 8px;

      .package-choose-item-price {
        font-weight: bold;
        height: 52px;
        line-height: 52px;
        font-size: 24px;
        margin: 0;

        span {
          font-size: 14px;
        }
      }

      .packahe-choose-item-desc {
        height: 27px;
        line-height: 27px;
        color: #FB694A;
        font-weight: bold;
        background: #FFE3E1;
        border-radius: 0px 0px 8px 8px;
      }
    }

    .package-item-action-desc {
      background: #FFFFFF !important;
      color: #FB694A !important;
    }

    .package-item-action {
      border: 1px solid #FE9C54 !important;
      color: #fff !important;
      background: linear-gradient(144deg, #FB674A 1%, #FE9C54 99%) !important;
    }

    .package-choose-item-defined {
      h1 {
        font-size: 20px;
        line-height: 60px;
      }
    }
  }

  .cardSetUp-action-btn {
    padding: 20px 20px 10px 20px;
    color: #fff;

    button {
      width: 100%;
      line-height: 36px;
      font-size: 16px;
      font-weight: bold;
      border-radius: 25px;
      background: #0D7FC6;
      border: none;
    }
  }

  .cardSetUp-tip {
    padding: 10px 20px 10px 20px;

    p {
      span {
        color: #FB684A;
      }

      color: #666666;
      font-size: 13px;
      line-height: 20px;
    }
  }

  .cardSetUp-tip1 {
    padding: 0px 0px 0px 20px;

    p {
      span {
        color: #FFA941;
      }

      line-height: 20px;
    }
  }

  .checkstand-defined {
    .checkstand-defined-popup {
      position: fixed;
      background-color: #fff;
      z-index: 92;
      width: 80%;
      min-height: 30%;
      top: 30%;
      left: 10%;
      border-radius: 15px;

      .input-defined {
        padding: 15px 0 0 30px;
        border-bottom: 1px solid #ccc;
        display: flex;

        span {
          display: inline-block;
          color: #3a3a3a;
          font-size: 16px;
          line-height: 47px;
        }
      }

      .btn-defined {
        padding: 30px 15px 20px 15px;

        button {

          background: rgba(255, 169, 65, 1);
          border: 0px solid rgba(255, 255, 255, 1);
          width: 100%;
          height: 36px;
          color: #fff;
          border-radius: 5px;
        }
      }

    }

    .close-icon {
      position: absolute;
      right: 5px;
      top: -15px;
    }

    h1 {
      margin-top: 5px;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
    }
  }
}

.changePasswordPanel-cardSetUp {
  padding: 10px;

  .icon-cross {
    position: absolute;
    right: 10px;
    font-size: 16px;
  }

  p {
    margin: 10px 16px 0 16px;
    line-height: 30px;
  }

  .confirmChangePassword {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    .confirmChangePasswordBtn {
      width: 80px;
      margin: 0 15px;
    }
  }

}

#rechargeB {
  background: #F5F5F5;
  height: 100%;

  .header {
    padding: 10px 16px;
    background: #fff;
    margin-bottom: 10px;

    div {
      color: #999;
      font-size: 15px;
      line-height: 30px;
    }

    div:nth-child(2) {
      color: #333;
      font-size: 18px;
    }
  }

  .packagePanel {
    // padding: 5px 16px;
    background: #fff;
    padding-bottom: 120px;

    .package {
      display: flex;
      position: relative;
      margin-bottom: 20px;

      .label-defined {
        display: block;
        border-width: 14px 18px 14px 18px;
        border-style: solid;
        border-color: transparent;
        position: absolute;

        label {
          position: absolute;
          left: -14px;
          top: -12px;
          background: transparent;
        }
      }

      .label-defined-active {
        // border-color: red transparent transparent red;
        background: #EEF2FE;
        border: 1px solid #436FD5;
      }

      .package-price {
        width: 80px;
        // border: 1px solid #FFA941;
        margin-right: 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        // background: linear-gradient(144deg, #FB674A 1%, #FE9C54 99%);
        border-radius: 5px;

        p {
          font-size: 14px;
          font-weight: bold;
          color: #397EF5;

          span {
            font-size: 24px;
            color: #397EF5;
          }
        }

      }

      .package-price.overlay-package {
        border-color: #07c160;
        background: #07c160;
      }

    }

  }

  .toRecharge {
    position: fixed;
    width: 100%;
    bottom: 0;
    font-size: 16px;
    background: #fff;

    .toRecharge-top {
      display: flex;
      background: #fff;

      .radio-group-defined {
        display: flex;
        padding-left: 20px;
        justify-content: center;
        align-items: center;
        height: 40px;

        div {
          height: 20px;
          margin-right: 15px;
        }
      }

    }

    .detail {
      color: #397EF5;
      background: #EFF5FF;
      padding-left: 20px;
      font-size: 12px;
      height: 22px;
      line-height: 22px;
    }

    .toRecharge-bottom {
      display: flex;

      p {
        padding-right: 15px;
        color: #333333;
        background: #fff;
        line-height: 45px;
        padding-left: 14px;
        width: 65%;
        font-size: 14px;

        span {
          color: #397EF5;
          font-size: 24px
        }
      }

      .toRechargeBtn {
        // padding: 0 30px;
        display: inline-block;
        line-height: 40px;
        height: 40px;
        color: #fff;
        margin: 6px 0;
        width: 35%;

        .n-btn {
          border-radius: 22px;
          text-align: center;
          background: #397EF5;
          width: 90%;
          margin: 0 auto;
        }
      }
    }

  }
}

.van-dialog {
  ::v-deep.van-dialog__content {
    flex-direction: column;
    justify-content: center;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
  }

  ::v-deep .van-dialog__header {
    font-size: 20px;
    font-weight: 700;
    color: #06121e;
    text-align: center;
    margin-bottom: 10px;
  }

  .dialog-text {
    font-size: 14px;
    color: #06121e;
    margin-top: 8px;
    line-height: 28px;
  }

  .btn-vis {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 25px;
  }

  .btn-vis1 {
    margin-top: 15px;

    .dialog-btn2,
    .dialog-btn3 {
      width: 100%;
      margin-bottom: 20px;
    }

    .other-btn {
      text-align: center;
      font-size: 16px;
      color: #999;
    }
  }

  .dialog-btn2 {
    width: 120px;
    height: 47px;
    color: #3476fe;
    text-align: center;
    background: rgba(52, 118, 254, 0.1) !important;
    border: 0 !important;
    border-radius: 94px;
    font-size: 16px;
    line-height: 47px;
  }

  .dialog-btn3 {
    width: 130px;
    height: 47px;
    border-radius: 94px;
    font-size: 16px;
    line-height: 47px;
    border: 0;
    color: #fff;
    background: #3476fe;
    text-align: center;
  }

}
</style>
